const unaddressedCountReducer = (state = 0, action) => {
    switch (action.type) {
        case 'UNADDRESSED_COUNT':
            return action.count;
        default:
            return state
    }
};

export default unaddressedCountReducer;
